











































import { mapState } from "vuex";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowLeft40px from "@/common/components/icons/IconArrowLeft40px.vue";
import IconArrowRight40px from "@/common/components/icons/IconArrowRight40px.vue";
import TextSanitized from "@/common/components/atoms/TextSanitized.vue";
import store from "@/general/store";
import { Prop, Vue, Component } from "vue-property-decorator";
import globals from "@/general/store/modules/globals";

@Component({
  components: {
    IconBase,
    IconArrowLeft40px,
    IconArrowRight40px,
    TextSanitized
  },
  store: store
})
export default class TheL04Pagination extends Vue {
  @Prop({ type: Object, required: false }) prevNews!: any;
  @Prop({ type: Object, required: false }) nextNews!: any;

  get prevLink() {
    return this.prevNews.link;
  }

  get nextLink() {
    return this.nextNews.link;
  }

  get prevTitle() {
    return this.prevNews.title;
  }
  get nextTitle() {
    return this.nextNews.title;
  }
}
